import { WorkOSUser } from "./src/workOSReact";

declare global {
  interface Window {
    __APP_DATA__?: {
      // Environment (e.g., "local", "develop", "qa", "production")
      env?: string;
      // Feature flags
      featureFlagConfiguration?: {
        clientKey?: string;
        enableDebugger?: boolean;
      };
      // WorkOS properties
      workosConfig?: {
        workosClientId?: string;
        user?: WorkOSUser;
      };
      // Pendo configuration
      pendoConfig?: {
        apiKey?: string;
      };
    };
  }
}
